import React, { memo } from 'react';
import styled from 'styled-components';

import Button from '../../../Button';

import { CreateTicket as CreateTicketIcon } from '@icons/common';

interface ICreateTicketButton {
  className?: string;
  onClick: () => void;
}

const CreateTicketButton = (props: ICreateTicketButton) => (
  <StyledCreateTicketButton {...props} functional title="Создать тикет">
    <StyledCreateTicketIcon />
  </StyledCreateTicketButton>
);

const StyledCreateTicketButton = styled(Button)`
  height: 14px;
`;

const StyledCreateTicketIcon = styled(CreateTicketIcon)`
  height: 100%;
  width: auto;
`;

export default memo(CreateTicketButton);
